import { createSelector } from 'reselect';
import { MODULE_NAME } from '../constants';

export const moduleState = (state) => state[MODULE_NAME] || {};

export const initPending = createSelector(moduleState, (m) => m.pending);

export const initDone = createSelector(moduleState, (m) => m.done);
